import request from '@/utils/request'
import { getCommunityId } from '@/api/community/communityApi'

// 查询未读消息数（前端 10s 轮询）
export function getUnreadCount() {
  return new Promise((resolve, reject) => {
    request({
      url: '/messageBox.getUnreadCount',
      method: 'post',
      // communityId 必填，未传时后端直接返回 count=0
      data: { communityId: getCommunityId() },
      // 轮询请求不弹全屏 loading
      showLoading: false
    }).then(response => {
      const res = response.data
      if (res.code == 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '获取未读消息数失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 分页查询消息列表
export function listMessages(params) {
  // params: { page, row, isRead?, msgType? }
  return new Promise((resolve, reject) => {
    request({
      url: '/messageBox.listMessages',
      method: 'post',
      // communityId 必填，与分页参数一起放在请求体
      data: Object.assign({ communityId: getCommunityId() }, params)
    }).then(response => {
      const res = response.data
      if (res.code == 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '获取消息列表失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 标记指定消息已读
export function markRead(msgIds) {
  // msgIds: ['msg1','msg2',...]
  return new Promise((resolve, reject) => {
    request({
      url: '/messageBox.markRead',
      method: 'post',
      data: {
        communityId: getCommunityId(),
        msgIds: msgIds
      }
    }).then(response => {
      const res = response.data
      if (res.code == 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '标记已读失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 当前小区全部消息标记已读
export function markAllRead() {
  return new Promise((resolve, reject) => {
    request({
      url: '/messageBox.markAllRead',
      method: 'post',
      data: { communityId: getCommunityId() }
    }).then(response => {
      const res = response.data
      if (res.code == 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '全部已读失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}
